/**
 * Generate human-readable sample codes for tests
 * 
 * Format: S-YYYYMMDD-HHMM-XXX
 * Where:
 *   S = Sample prefix
 *   YYYYMMDD = Date (20260104)
 *   HHMM = Time (1430)
 *   XXX = Random 3-char uppercase alphanumeric
 * 
 * Examples:
 *   S-20260104-1430-X7K
 *   S-20260104-1432-B9M
 *   S-20260104-1455-Q2P
 */
export function generateSampleCode(): string {
  const date = new Date();
  
  // Date: YYYYMMDD
  const dateStr = date.toISOString().split('T')[0].replace(/-/g, '');
  
  // Time: HHMM
  const timeStr = date.toTimeString().split(' ')[0].replace(/:/g, '').slice(0, 4);
  
  // Random: 3 uppercase alphanumeric chars for uniqueness
  const random = Math.random().toString(36).substring(2, 5).toUpperCase();
  
  // Format: S-YYYYMMDD-HHMM-XXX
  return `S-${dateStr}-${timeStr}-${random}`;
}
